// 다음 광고 방문 공통 스크립트
export const addCommonDaumScript = () => {
  if (process.env.STAGE !== 'production') return;

  const newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  const inlineScript = document.createTextNode('kakaoPixel("2329354071550767951").pageView("방문");');
  newScript.appendChild(inlineScript);
  document.body.appendChild(newScript);
};

// 다음 광고 로그분석 스크립트
export const addConversionDaumScript = (key, value) => {
  if (process.env.STAGE !== 'production') return;

  const newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  const inlineScript = document.createTextNode(`kakaoPixel("2329354071550767951").pageView();kakaoPixel("2329354071550767951").${key}("${value}");`);
  newScript.appendChild(inlineScript);
  document.body.appendChild(newScript);
};

export const addPurchaseDaumScript = value => {
  if (process.env.STAGE !== 'production') return;

  const newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  const inlineScript = document.createTextNode(`kakaoPixel("2329354071550767951").pageView();kakaoPixel("2329354071550767951").purchase(${value});`);
  newScript.appendChild(inlineScript);
  document.body.appendChild(newScript);
};
